(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-slider-hicc"] && !Shopify.designMode) return;
  try {
    
if (!window.Eurus.loadedScript.has('before-after-slider-hicc.js')) {
  window.Eurus.loadedScript.add('before-after-slider-hicc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xImageComparisonHicc', (sectionId) => ({
        load(e) {
          this.$refs.image.style.setProperty('--compare_hicc_' + sectionId, e.target.value + '%');
        },
        resizeWindow(el) {
          addEventListener("resize", () => {
            this.setMinMaxInput(el);
          });
        },
        disableScroll(el) {
          let isfocus = true;
          window.addEventListener('wheel', () => {
            if (isfocus) {
              el.blur();
              isfocus = false;
            }
          });
        },
        setMinMaxInput(el) {
          el.min = 0;
          el.max = 100;
        },
        animateValue(el) {
          const targetValue = parseFloat(el.value);
          let currentValue = 50;
          const totalDuration = 1000;
          let startTime = null; 
        
          const easeInOutSlowEnd = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
        
          const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsedTime = timestamp - startTime;
            const progress = Math.min(elapsedTime / totalDuration, 1);
        
            const easedProgress = easeInOutSlowEnd(progress);
        
            currentValue = 50 + (targetValue - 50) * easedProgress; 
            el.value = currentValue.toFixed(2);
            this.$refs.image.style.setProperty('--compare_hicc_' + sectionId, currentValue + '%');
        
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.value = targetValue; 
              this.$refs.image.style.setProperty('--compare_hicc_' + sectionId, targetValue + '%');
            }
          };
        
          requestAnimationFrame(step);
        }        
      }));
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var root = document.querySelector('#section-footer .market-switch-pc');
    if (!root) return;
    var trigger = root.querySelector('.market-switch-trigger');
    var dropdown = root.querySelector('.market-switch-dropdown');
    if (!trigger || !dropdown) return;

    function setOpen(open) {
      dropdown.classList.toggle('active', open);
      root.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!dropdown.classList.contains('active'));
    });

    document.addEventListener('click', function () {
      setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veterinary-day-banner-hicc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const scrollOffset = 120;

  const pad2 = (n) => String(Math.max(0, n)).padStart(2, '0');

  const copyText = async (text) => {
    if (!text) return false;
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (_e) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    }
  };

  const tickCountdown = (root) => {
    const endStr = root.getAttribute('data-countdown-end');
    if (!endStr) return;
    const end = Date.parse(endStr);
    if (Number.isNaN(end)) return;
    const block = root.querySelector('[data-countdown-block]');
    const wrap = root.querySelector('[data-countdown-root]');
    if (!wrap || !block) return;
    const elD = wrap.querySelector('[data-cd-days]');
    const elH = wrap.querySelector('[data-cd-hours]');
    const elM = wrap.querySelector('[data-cd-minutes]');
    const elS = wrap.querySelector('[data-cd-seconds]');
    if (!elD || !elH || !elM || !elS) return;

    let timerId = null;

    const update = () => {
      const diff = end - Date.now();
      if (diff <= 0) {
        elD.textContent = '00';
        elH.textContent = '00';
        elM.textContent = '00';
        elS.textContent = '00';
        if (timerId) {
          clearInterval(timerId);
          timerId = null;
        }
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      elD.textContent = pad2(days);
      elH.textContent = pad2(hours);
      elM.textContent = pad2(minutes);
      elS.textContent = pad2(seconds);
    };

    update();
    if (end > Date.now()) {
      timerId = setInterval(update, 1000);
    }
  };

  document.querySelectorAll('[data-vet-day-hero]').forEach((root) => {
    tickCountdown(root);

    root.querySelectorAll('[data-copy-trigger]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const value = btn.getAttribute('data-copy-value') || '';
        const ok = await copyText(value);
        const tip = root.querySelector('[data-copy-feedback]');
        if (!tip) return;
        tip.textContent = ok ? 'Copied' : 'Copy failed';
        tip.classList.remove('opacity-0');
        clearTimeout(tip._copyTimer);
        tip._copyTimer = setTimeout(() => tip.classList.add('opacity-0'), 1600);
      });
    });
  });

  document.querySelectorAll('.x-section-veterinary-day-banner-hicc').forEach((root) => {
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;
      const href = link.getAttribute('href');
      if (!href || href.length < 2) return;
      const id = href.slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      const top = window.pageYOffset + target.getBoundingClientRect().top - scrollOffset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      if (window.location.hash !== href) {
        history.replaceState(null, '', href);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
